import Vue from 'vue';
import Countly from 'countly-sdk-web';
import VueCountly from 'vue-countly';

Vue.use(VueCountly, Countly, {
  app_key: process.env.VUE_APP_COUNTLY_APP_KEY,
  url: process.env.VUE_APP_COUNTLY_URL
});
Countly.q.push(['track_sessions']);
Countly.q.push(['track_pageview']);

export default Countly;
